/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

import { html, LitElement } from 'lit-element';
import dividerStyles from './sh-divider.lit.scss.js';
/**
 * @prop {String} spacing - Defines the margin around the divider line. Possible values are `S` (0.5rem), `M` (1rem), `L` (1.5rem) and `XL` (3rem)
 * @prop {Boolean} vertical - If set, the divider will have a vertical orientation
 */
export class SHDivider extends LitElement {
  static get properties() {
    return {
      spacing: { type: String, reflect: true },
      vertical: { type: Boolean, reflect: true },
    };
  }

  static get styles() {
    return [dividerStyles];
  }

  render() {
    return html` <div class="divider-wrapper"></div> `;
  }

  attributeChangedCallback(name, oldval, newval) {
    super.attributeChangedCallback(name, oldval, newval);
    this.dispatchEvent(new Event(`${name}-changed`));
  }

  constructor() {
    super();
    this.spacing = 's';
  }
}

customElements.define('sh-divider', SHDivider);
